module.exports = __webpack_public_path__ + "assets/img/Large_3.c5517344.svg";